import Vue from "vue";
import Vuex from "vuex";

// modules
import auth from "./modules/auth";
import popup from "./modules/popup";
import prescription from "./modules/prescription";
import system from "./modules/system";
import treatment from "./modules/treatment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: () => ({
    // ...auth.state(),
    // ...system.state(),
  }),
  getters: {
    // ...auth.getters,
    // ...system.getters,
  },
  mutations: {
    // ...auth.mutations,
    // ...system.mutations,
  },
  actions: {
    // ...auth.actions,
    // ...system.actions,
  },
  modules: {
    auth,
    popup,
    prescription,
    system,
    treatment,
  },
});
